"use client";

import { getBorderRadius, getDesktop, getMobile } from "@/utils/theme-helper";

export interface VideoComponentProps {
  url: string;
  type: string;
  height: string;
  width: string;
  rounded?: string;
}

const VideoComponent: React.FC<{
  config: VideoComponentProps;
}> = ({ config }) => {
  if (!config.url) {
    return null;
  }

  const mobileWidth = getMobile("w-full", config.width);
  const desktopWidth = getDesktop("w-full", config.width);
  const mobileHeight = getMobile("h-full", config.height);
  const desktopHeight = getDesktop("h-full", config.height);

  return (
    <div
      style={
        {
          "--mobile-width": mobileWidth,
          "--desktop-width": desktopWidth,
          "--mobile-height": mobileHeight,
          "--desktop-height": desktopHeight,
          "--rounding-video-mobile": getBorderRadius(
            getMobile("", config.rounded),
            "video"
          ),
          "--rounding-video-desktop": getBorderRadius(
            getDesktop("", config.rounded),
            "video"
          ),
        } as React.CSSProperties
      }
      className={`homepage-image-rounded w-full h-full overflow-hidden ${mobileWidth !== "none" ? "w-[var(--mobile-width)]" : "w-full"} ${desktopWidth !== "none" ? "md:w-[var(--desktop-width)]" : "w-full"} ${mobileHeight !== "none" ? "h-[var(--mobile-height)]" : "h-full"} ${desktopHeight !== "none" ? "md:h-[var(--desktop-height)]" : "h-full"}`}
    >
      {config?.type === "realequity" && config?.url && (
        <video
          autoPlay
          loop
          muted
          playsInline
          className="object-cover h-full w-full"
        >
          <source src={config.url} type="video/mp4" />
        </video>
      )}
      {config?.type === "youtube" && config?.url && (
        <iframe
          width="100%"
          height="100%"
          src={config.url}
          title="youtube"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="w-full h-full"
        ></iframe>
      )}
      {config?.type === "vimeo" && config?.url && (
        <iframe
          title="vimeo"
          src={config.url}
          width="100%"
          height="100%"
          allow="autoplay; fullscreen; picture-in-picture"
          className="w-full h-full"
        ></iframe>
      )}
    </div>
  );
};

export default VideoComponent;
